
export const dataDefault = [{
    sort: 0,
    name: "Labor Cost 人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 1,
    name: "Total Available Rooms 总房数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 2,
    name: "Total Rooms Occupied 总出租房",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 3,
    name: "Occupancy % 出租率%",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 4,
    name: "Average Room Rate 平均每天房价",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 5,
    name: "Total Revenue 总收入",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 6,
    name: "Rooms Revenue 客房收入",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 7,
    name: "F&B Revenue 餐饮收入",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 8,
    name: "Other Revenue 其他收入",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 9,
    name: "GOP 经营利润",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 10,
    name: "Salary 工资 (纯工资)",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 11,
    name: "Incentive Program/Bonus Provision 绩效考核奖金/年终奖预提",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 12,
    name: "Overtime 加班工资",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 13,
    name: "Vacation 法定假期",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 14,
    name: "Meal 工作餐费",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 15,
    name: "Social Insurance and Housing Fund 社保和公积金",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 16,
    name: "Other Related Benefits 其他福利 <br/>(包括合同津贴，交通、住宿、通讯补贴， 加班工资，法定假期，工作餐费等)",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 17,
    name: "Total Labor Cost 人力成本总计<br/>（包含工资及福利费用合计，不含劳务外包及帮工费用）",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 18,
    name: "Productivity 生产率",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 19,
    name: "本年度实际经营月份数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 20,
    name: "本年度实际经营天数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 21,
    name: "Total Staff Number 员工总数 (累计数，包含实习生，不包含临时工)",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 22,
    name: "Average Staff Number 平均每月员工数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 23,
    name: "Staff Numbers / Total Available Rooms 员工总数/ 总房数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 24,
    name: "Total Labor Cost / Total Revenue 总人力成本/ 总收入",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 25,
    name: "Total Labor Cost / Total Staff Numbers<br/> 总人力成本/ 员工总数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 30,
    name: "Total Salary / Total Staff Numbers 总员工工资/ 员工总数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 31,
    name: "Rooms Staff 客房部员工总数 (包括前台)",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 32,
    name: "Rooms Labor Cost 客房部门人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 33,
    name: "Rooms Total Salary 客房部门员工工资（仅工资）",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 34,
    name: "Rooms Revenue / Total Revenue 客房收入/ 总收入",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 35,
    name: "Rooms Labor Cost / Total Labor Cost<br/> 客房部门人力成本/ 总人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 36,
    name: "Rooms Labor Cost / Rooms Staff<br/> 客房部门人力成本/ 客房部员工总数 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 37,
    name: "Rooms Total Salary / Rooms Staff<br/> 客房部门员工工资/ 客房部员工总数 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 38,
    name: "Rooms Revenue / Rooms Staff 客房收入/ 客房部员工数（Productivity 劳动生产率）",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 39,
    name: "F&B Staff 餐饮部员工总数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 40,
    name: "F&B Labor Cost 餐饮部门人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 41,
    name: "F&B Total Salary 餐饮部门员工工资（仅工资）",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 42,
    name: "F&B Revenue / Total Revenue 餐饮收入/ 总收入",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 43,
    name: "F&B Labor Cost / Total Labor Cost 餐饮部门人力成本/ 总人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 44,
    name: "F&B Labor Cost / F&B Staff 餐饮部门人力成本/ 餐饮部员工总数 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 45,
    name: "F&B Total Salary / F&B Staff 餐饮部门员工工资/ 餐饮部员工总数 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 46,
    name: "F&B Revenue / F&B Staff 餐饮收入/ 餐饮部员工人数 （Productivity 劳动生产率）",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 47,
    name: "Other Operating Staff 其他营业部门员工总数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 48,
    name: "Other Operating Labor Cost 其他营业部门人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 49,
    name: "Other Operating Salary 其他营业部门员工工资 (仅工资)",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 50,
    name: "Other Operating Revenue / Total Revenue 其他营业部门收入/ 总收入",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 51,
    name: "Other Operating Labor Cost / Total Labor Cost<br/> 其他营业部门人力成本/ 总人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 52,
    name: "Other Operating Labor Cost / Other Operating Staff <br/> 其他营业部门人力成本/ 其他营业部门员工总数 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 53,
    name: "Other Operating Total Salary / Other Operating Staff<br/> 其他营业部门员工工资/ 其他营业部门员工总数 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 54,
    name: "Other Operating Revenue / Other Operating Staff<br/> 其他营业部门收入/ 其他营业部门员工人数 （Productivity 劳动生产率）",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 55,
    name: "Undistributed Staff 后台部门员工总数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 56,
    name: "Undistributed Labor Cost 后台部门人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 57,
    name: "Undistributed Salary 后台部门员工工资 (仅工资)",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 58,
    name: "Undistributed Labor Cost / Total Labor Cost<br/> 后台部门人力成本/ 总人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 59,
    name: "Undistributed Labor Cost / Undistributed Staff <br/>后台部门人力成本/ 后台部门员工总数 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 60,
    name: "Undistributed Total Salary / Undistributed Staff <br/>后台部门员工工资/ 后台部门员工总数 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 61,
    name: " Staff No. Check",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 62,
    name: "Labor Cost Check",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 63,
    name: "Including 其中：",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 64,
    name: "Trainee 总实习生人数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 65,
    name: "Total Trainee / Total Staff Number 总实习生人数/ 员工总数",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 66,
    name: "Trainee Cost 总实习生费用支出 - 工资",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 67,
    name: "Trainee Cost 总实习生费用支出 - 管理费 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 68,
    name: "Average of Trainee Cost 每个实习生平均费用 ",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 69,
    name: "Departments Expenses 各部门劳务费用（包括临时帮工及外包费用）",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 70,
    name: "F&B 酒店餐饮劳务费用",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 71,
    name: "Rooms 酒店房务劳务费用",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 72,
    name: "Total Labor Outsourcing Expenses 酒店劳务费用合计",
    now_year: 0,
    last_year: 0,
    variance: 0
}, {
    sort: 73,
    name: "Total Labor Outsourcing Expenses / Total Labor Cost 酒店劳务费用合计/总人力成本",
    now_year: 0,
    last_year: 0,
    variance: 0
}]


// WEBPACK FOOTER //
// ./src/hr/table/9.0/data.js